export default function Timer() {
  return '<div class="tm-c-timer" style="width: 0"></div>';
}
